import React, { useEffect, useState } from 'react';
import { Box, Button, Checkbox, FormControlLabel, Grid, Paper, TextField, Typography } from '@mui/material';
import { programAPI } from '../../services/api';

export default function NurseChart({ studentId }) {
  const [chart, setChart] = useState(null);
  const [med, setMed] = useState('');
  const [kind, setKind] = useState('DTaP');

  const load = () => {
    programAPI.nurseChart(studentId).then((res) => setChart(res.data)).catch(() => setChart(null));
  };

  useEffect(() => { if (studentId) load(); }, [studentId]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!chart) return null;
  const forms = chart.forms || {};

  const saveFlag = (field, value) => {
    programAPI.saveNurseChart(studentId, { kind: 'forms', [field]: value }).then(load);
  };

  return (
    <Paper sx={{ p: 2, mt: 2 }}>
      <Typography variant="h6" gutterBottom>Nurse chart</Typography>
      <Typography variant="body2">Allergy emergency plan: {chart.flags?.has_allergy_emergency_plan ? 'Yes' : 'No'}. Individual healthcare plan: {chart.flags?.has_individual_healthcare_plan ? 'Yes' : 'No'}.</Typography>
      <Typography variant="body2" sx={{ mb: 1 }}>Prescribing physician: {chart.flags?.rx_physician_name || '—'} {chart.flags?.rx_physician_license || ''}</Typography>
      <Typography variant="body2">Physical: {forms.physical_date || '—'} {forms.physical_physician_name || ''} {forms.physical_physician_license || ''}</Typography>
      <Grid container>
        {[
          ['emergency_contact_card_received', 'Emergency card'],
          ['special_alert_form_received', 'Alert form'],
          ['consent_to_treat_received', 'Consent to treat'],
          ['takes_meds_at_home', 'Meds at home'],
          ['fully_immunized', 'Fully immunized'],
        ].map(([field, label]) => (
          <Grid item xs={12} sm={6} key={field}>
            <FormControlLabel
              control={<Checkbox checked={Boolean(forms[field])} onChange={(e) => saveFlag(field, e.target.checked)} />}
              label={label}
            />
          </Grid>
        ))}
      </Grid>
      <Typography variant="subtitle1" sx={{ mt: 2 }}>Immunizations</Typography>
      {(chart.immunizations || []).map((row) => (
        <Typography key={row.id} variant="body2">{row.kind} {row.date || (row.complete ? 'complete' : '')}</Typography>
      ))}
      <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
        <TextField size="small" label="Kind" value={kind} onChange={(e) => setKind(e.target.value)} />
        <Button onClick={() => programAPI.saveNurseChart(studentId, { kind: 'immunization', immunization_kind: kind, complete: true }).then(load)}>Add</Button>
      </Box>
      <Typography variant="subtitle1" sx={{ mt: 2 }}>Medications in the office</Typography>
      {(chart.medications || []).map((row) => (
        <Typography key={row.id} variant="body2">{row.medication} — Rx {row.rx_expires || '—'} / med {row.medication_expires || '—'}</Typography>
      ))}
      <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
        <TextField size="small" label="Medication" value={med} onChange={(e) => setMed(e.target.value)} />
        <Button onClick={() => programAPI.saveNurseChart(studentId, { kind: 'medication', medication: med }).then(() => { setMed(''); load(); })}>Add</Button>
      </Box>
    </Paper>
  );
}
